import { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';

function getTranslationProvider(scope: string): Provider {
  return provideTranslocoScope({ scope, alias: scope });
}

export { getTranslationProvider };
